import {
    SET_EXTERNAL_DATA
} from './../constants/constants';

const initialState = {
    riskItemId: null,
    redirectType: null,
    redirectIdentifier: null,
}

const externalReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_EXTERNAL_DATA:
            return {
                ...state,
                riskItemId:('riskItemId' in action.payload)? action.payload.riskItemId : state.riskItemId,
                redirectType:('redirectType' in action.payload)? action.payload.redirectType : state.redirectType,
                redirectIdentifier:('redirectIdentifier' in action.payload)? action.payload.redirectIdentifier : state.redirectIdentifier,
            }
        default:
            return state
    }
};

export default externalReducer;